import { apiClient } from '@/services/api';
import type { ApiResponse } from '@/types/auth';
import type { ManualFundResult, WalletProviderSettings } from '@/types/wallet';

class AdminWalletService {
  getProviderSettings(provider = 'palmpay') {
    return apiClient.get<ApiResponse<{ settings: WalletProviderSettings }>>(
      `/admins/wallet/providers/${provider}`,
    );
  }

  updateProviderSettings(
    provider: string,
    data: Partial<{
      enabled: boolean;
      identityType: WalletProviderSettings['identityType'];
      identityLicense: string | null;
      chargePercent: number;
      chargeCap: number;
    }>,
  ) {
    return apiClient.put<ApiResponse<{ settings: WalletProviderSettings }>>(
      `/admins/wallet/providers/${provider}`,
      data,
    );
  }

  manualFundUser(userId: number, amount: number, note?: string) {
    return apiClient.post<ApiResponse<ManualFundResult>>(`/admins/users/${userId}/wallet/fund`, {
      amount,
      note,
    });
  }
}

export const adminWalletService = new AdminWalletService();
